import { logUsage } from 'owa-analytics';
import { createLazyOrchestrator } from 'owa-bundling';
import onOfficeAppClick from '../actions/onOfficeAppClick';
import { lazyLogFloodgateActivity } from 'owa-floodgate-feedback-view';
import { isHostAppFeatureEnabled } from 'owa-hostapp-feature-flags';

export const onOfficeAppClickOrchestrator = createLazyOrchestrator(
    onOfficeAppClick,
    'clone_onOfficeAppClick',
    actionMessage => {
        const { app, currentlySelectedModule } = actionMessage;

        if (currentlySelectedModule) {
            logUsage(`leftNav${app}ButtonClicked`, [currentlySelectedModule.toString()], {
                isCore: true,
            });
        }

        if (isHostAppFeatureEnabled('floodgate')) {
            lazyLogFloodgateActivity.import().then(logFloodgateActivity => {
                logFloodgateActivity('OfficeAppClick');
            });
        }
    }
);
